module.exports = __webpack_public_path__ + "img/wallet_icon.b2002521.svg";